import React, { useEffect, useState } from "react";
import BOM from "@system/config/bom";
import System from "src/helper/system";
import { useBOMStore } from "src/hooks/bom";
import NavigateToProductDetail from "../../../component/custom/NavigateToProductDetail";
import { useCartStore } from "src/hooks/cart";
import HelperAdobeEvent from "src/support/HelperAdobeEvent";
import { useProductInventoryPriceStore } from "src/hooks/productInventoryPrice";
import { useSystem } from "src/hooks/system";

const AddedToBomPopup = (props) => {
  const { data, SetStatus } = props;
  const [{ CART_BEFORE_TO_SEND_SERVER }, { }, { }] = useCartStore();
  const [isSubmitting, setIsSubmitting] = useState(false);
  let { single_product, bomNoMatchType, bomId, bomDetailId } = data;
  const [
    { bom_detail_by_bom_id, bom_detail_by_bom_id_type, bom_project_list },
    { },
    { add_part_to_bom, swap_part_number, create_params_for_add_part_to_bom },
  ] = useBOMStore();
  const [
    { },
    { get_inventory_by_id, get_pricing_by_id, get_current_price_by_quantity },
    { },
  ] = useProductInventoryPriceStore();
  const bom_id = System.getParams().bomId;
  const [,{ get_quantity_format }] = useSystem();
  useEffect(() => {
    async function fetchHere() {
      if (data) {
        const ErpPartNumber = single_product.ItemNumber;
        let params = await create_params_for_add_part_to_bom({
          ...single_product,
          bomIds: [bomId],
        });

        if (bomDetailId && bomId && bomNoMatchType === "true") {
          params.bomDetailId = bomDetailId;
          params.bomId = bomId;
          params.designWinFlag = single_product?.DesignWinFlag;
          await swap_part_number(params);
        } else {
          await add_part_to_bom(params);
        }
        noMatchesEvent();
      }
    }

    fetchHere();
  }, [data]);

  const getLatestQuantity = () => {
    if (
      CART_BEFORE_TO_SEND_SERVER &&
      single_product?.ItemNumber &&
      CART_BEFORE_TO_SEND_SERVER[single_product.ItemNumber] &&
      CART_BEFORE_TO_SEND_SERVER[single_product.ItemNumber].quantityUpdateToCart
    ) {
      return CART_BEFORE_TO_SEND_SERVER[single_product.ItemNumber]
        .quantityUpdateToCart;
    }
    return single_product.QtyMin !== null ? single_product.QtyMin : 0;
  };

  //By Ramya Kannan - [Bom No matches resolved - Adobe script]

  function noMatchesEvent() {
    let prodDetails = { ...single_product };
    let getBomDetails = bom_detail_by_bom_id;
    let bomDetails = { ...getBomDetails };
    if (bom_project_list) {
      bomDetails.projectName =
        bom_project_list[bom_detail_by_bom_id.projectId]?.projectName;
    }
    bomDetails.exactMatchCount = bom_detail_by_bom_id_type?.Exact?.count;
    bomDetails.nomatchCount = bom_detail_by_bom_id_type?.NoMatch?.count;
    bomDetails.multipleMatchCount = bom_detail_by_bom_id_type?.Multiple?.count;

    prodDetails.qas =
      get_inventory_by_id(prodDetails.ItemNumber)?.inventoryQty || 0;
    let priceVal = getPricing(prodDetails);
    prodDetails.priceSource = priceVal?.priceSource;
    prodDetails.unitPrice = prodDetails.unitPrice || priceVal?.marketPrice;
    prodDetails.subtotal = prodDetails.subtotal || (priceVal?.marketPrice * priceVal?.quantity);


    prodDetails.Quantity = getLatestQuantity();

    localStorage.setItem("adobeEventType", "bomNoMatchesResolved");
    if (Object.keys(prodDetails).length) {
      HelperAdobeEvent.trackingAdobeEvent({ prodDetails, bomDetails });
    }
  }

  const getPricing = (ele) => {
    let priceValues = get_pricing_by_id({
      uniqueId: ele.bomDetailId ? ele.bomDetailId : ele.ItemNumber,
    });
    return priceValues && priceValues[0];
  };

  const onHide = (action = true) => {
    SetStatus(false);
  };
  const getLatestQtyAndPrice = get_current_price_by_quantity(
    get_pricing_by_id({ ItemNumber: single_product.ItemNumber }),
    getLatestQuantity(),
    true
  );
  return (
    <>
      <div className="avnet-modal modal-800">
        <div className="avnet-modal-inner">
          <button
            type="button"
            className="close py-3"
            disabled={isSubmitting}
            data-dismiss="modal"
            onClick={() => {
              onHide();
            }}
          >
            ×
          </button>
          <div className="modal-header border-0">
            <h3 className="modal-title m-auto" id="exampleModalLabel">
              Added to your BOM
            </h3>
          </div>
          <div className="modal-body">
            <p className="text-center mb-4">
              This item has been added to your “Exact Matches”
            </p>
            <div className="bs5 ms-5 me-5 mb-4">
              {Object.keys(single_product).length > 0 && (
                  <table className="table table-bordered">
                    <thead>
                      <tr>
                        <th className="bg-grey2">Product</th>
                        <th className="bg-grey2">Manufacturer</th>
                        <th className="bg-grey2">Quantity</th>
                        <th className="bg-grey2">Price</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <NavigateToProductDetail data={{SEOManufacturerName:single_product?.SEOManufacturerName,SEOERPMFRPartNumber:single_product?.SEOERPMFRPartNumber, ItemNumber: single_product?.ItemNumber,ERPPartNumber: single_product?.ERPPartNumber,}}>
                            {single_product.ERPMFRPartNumber}
                          </NavigateToProductDetail>
                        </td>
                        <td className="font-bold">
                          {single_product.ManufacturerName}
                        </td>
                        <td className="font-bold">{get_quantity_format(getLatestQuantity())}</td>
                        <td className="font-bold">
                          {getLatestQtyAndPrice?.marketPrice ? window.mct : " "}{" "}
                          {System.getFormatNumber({
                            amount:
                              Number(getLatestQtyAndPrice?.marketPrice) || 0,
                            maximumFractionDigits: 2,
                            isDisplaySymbol: true,
                          }) || 0}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                )}
            </div>
          </div>
          <div className="modal-footer d-flex justify-content-center">
            <button
              type="button"
              className="bs5 btn btn-secondary w145"
              disabled={isSubmitting}
              onClick={() => {
                onHide();
              }}
            >
              CLOSE
            </button>
            <button
              type="button"
              className="bs5 btn btn-primary w145"
              disabled={isSubmitting}
              onClick={() => {
                setIsSubmitting(true);
                window.location.href = BOM.getBomDetailByIdRouteURL(bom_id, {
                  go: System.getParams().go,
                });
              }}
            >
              {isSubmitting ? <i className="fa fa-spinner fa-spin" /> : <>Return to Bom</>}
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddedToBomPopup;
